import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Stack,
  styled,
} from "@mui/material";
import { FormatFullName } from "app/utils/helper";
import { useSelector } from "react-redux";
import { selectSelectedSchool } from "app/modules/schools/selectors";

// Template 2 (Compact Design)
const TransportCardTemplate2 = ({ student, index, pageIndex, color, selectedSession }) => {
  const selectedSchool = useSelector(selectSelectedSchool);
  const fullName = FormatFullName(
    student?.studentDocId?.firstName,
    student?.studentDocId?.middleName,
    student?.studentDocId?.lastName
  );

  return (
    <React.Fragment key={student?._id || `${pageIndex}-${index}`}>
      <CardContainer color={color}>
        {/* Compact header */}
        <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "primary.main" }}
          >
            {selectedSchool?.schoolName || "--"}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            TRANSPORT CARD
          </Typography>
        </Stack>

        {/* Main content in single row */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          {/* Student photo */}
          <Avatar
            variant="square"
            src={
              student?.studentDocId?.profilePic || student?.profilePicture || ""
            }
            sx={{
              width: 80,
              height: 80,
              borderRadius: 2,
              objectFit: "cover",
            }}
          />

          {/* Student details */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              {fullName || "--"}
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 0.5,
              }}
            >
              <Typography variant="body2">
                <strong>Class:</strong>{" "}
                {student?.studentDocId?.className || student?.class || "--"}
              </Typography>
              <Typography variant="body2">
                <strong>Mobile:</strong>{" "}
                {student?.studentDocId?.mobileNumber || "--"}
              </Typography>
              <Typography variant="body2">
                <strong>Route:</strong>{" "}
                {student?.routeNumber || student?.route || "--"}
              </Typography>
              <Typography variant="body2">
                <strong>Stop:</strong> {student?.to || "--"}
              </Typography>
              <Typography variant="body2">
                <strong>Driver:</strong> {student?.driverName || "--"}
              </Typography>
              <Typography variant="body2">
                <strong>Driver Mobile:</strong> {student?.driverMobile || "--"}
              </Typography>
            </Box>
          </Box>

          {/* Session info */}
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Session: {selectedSession || "--"}
            </Typography>
          </Box>
        </Box>
      </CardContainer>
    </React.Fragment>
  );
};

export default TransportCardTemplate2;

const CardContainer = styled(Box)(({ color = "#e6ffe9" }) => ({
  borderRadius: 12,
  backgroundColor: color,
  border: "1px solid rgba(0,0,0,0.08)",
  padding: 16,
  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  marginBottom: 12,
  pageBreakInside: "avoid",
  WebkitPrintColorAdjust: "exact",
  "& .MuiTypography-root": {
    color: "rgba(0,0,0,0.92)",
  },
  "@media print": {
    backgroundColor: color,
    boxShadow: "none",
    border: "1px solid #000",
    borderRadius: 6,
    marginBottom: 8,
    padding: 10,
    minHeight: "120px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .MuiTypography-root": {
      color: "#000",
      WebkitPrintColorAdjust: "exact",
    },
    "& .MuiDivider-root": {
      borderColor: "#000",
      backgroundColor: "#000",
    },
  },
}));